<div ui-view="headerView"></div>
<div class="main-wrapper">
    <div ui-view="maintenanceAlertView"></div>
    <div ui-view="mainView" class="main-view"
         (click)="handleClickOutside()"
         (scroll)="onScroll($event)">
    </div>
</div>
<div ui-view="footerView"></div>
<div ui-view="alertView"></div>
